<template>
  <div class="lgprStakeholders">
    <el-table
      :data="stakeholders"
      style="width: 100%;"
      stripe
      class="stakeholderTable"
    >
      <el-table-column label="Name">
        <template slot-scope="scope">
          {{ scope.row.first_name }} {{ scope.row.last_name }}
        </template>
      </el-table-column>
      <el-table-column
        label="Email"
        prop="email"
      />
      <el-table-column label="Org. Relationship">
        <template slot-scope="scope">
          {{ scope.row.org_relationship | relationshipDisplay }}
        </template>
      </el-table-column>
      <el-table-column label="Survey Language">
        <template slot-scope="scope">
          {{ scope.row.survey_language | langDisplay }}
        </template>
      </el-table-column>
      <el-table-column width="100">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.org_relationship !== 'self'"
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-form
      ref="stakeholderForm"
      label-width="130px"
      :model="stakeholderForm"
      class="stakeholderForm"
      :rules="rules"
    >
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item
            label="First name"
            prop="first_name"
          >
            <el-input v-model="stakeholderForm.first_name" />
          </el-form-item>
          <el-form-item
            label="Last name"
            prop="last_name"
          >
            <el-input
              v-model="stakeholderForm.last_name"
              prop="last_name"
            />
          </el-form-item>
          <el-form-item
            label="Email"
            prop="email"
          >
            <el-input
              v-model="stakeholderForm.email"
              prop="email"
            />
          </el-form-item>
          <el-form-item
            label="Phone number"
            prop="phone_number"
          >
            <el-input
              v-model="stakeholderForm.phone_number"
              prop="phone_number"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Org. relationship"
            prop="org_relationship"
          >
            <el-select v-model="stakeholderForm.org_relationship">
              <el-option
                v-for="(relationship, key) in organizationalRelationshipOptions"
                :key="key"
                :label="relationship.label"
                :value="relationship.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="Survey language"
            prop="survey_language"
          >
            <el-select v-model="stakeholderForm.survey_language">
              <el-option
                v-for="(lang, key) in surveyLanguageOptions"
                :key="key"
                :label="lang.label"
                :value="lang.value"
                :disabled="lang.value !== 'english'"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button @click="resetForm">
          Cancel
        </el-button>
        <el-button
          type="primary"
          @click="submit"
        >
          Add
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '@/api';

export default {
  filters: {
    relationshipDisplay(value) {
      switch (value) {
        case 'manager':
          return 'Manager';
        case 'peer':
          return 'Peer';
        case 'direct_report':
          return 'Direct report';
        case 'other':
          return 'Other';
        case 'self':
          return 'Self';
        default:
          return '';
      }
    },

    langDisplay(value) {
      switch (value) {
        case 'english':
          return 'English (United States)';
        case 'fr':
          return 'French (France)';
        case 'du':
          return 'Dutch (Netherlands)';
        case 'po':
          return 'Portuguese (Brazil)';
        default:
          return '';
      }
    },
  },

  props: {
    stakeholders: {
      type: Array,
      default() {
        return [{
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
          org_relationship: '',
          survey_language: '',
        }];
      },
    },
  },

  data() {
    return {
      stakeholderForm: {
        // first_name: '',
        // last_name: '',
        // email: '',
        // phone_number: '',
        // org_relationship: '',
        // survey_language: '',
        first_name: 'Benjamin',
        last_name: 'Vasseur',
        email: 'bpv2@sccoaching.com',
        phone_number: '',
        org_relationship: 'peer',
        survey_language: 'english',
      },
      rules: {
        first_name: [
          { required: true, message: 'First name is required', trigger: 'blur' },
        ],
        last_name: [
          { required: true, message: 'Last name is required', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur'] },
        ],
        org_relationship: [
          { required: true, message: 'Organizational relationship is required', trigger: 'blur' },
        ],
        survey_language: [
          { required: true, message: 'Survey language is required', trigger: 'blur' },
        ],
      },
      organizationalRelationshipOptions: [
        {
          value: 'manager',
          label: 'Manager',
        },
        {
          value: 'peer',
          label: 'Peer',
        },
        {
          value: 'direct_report',
          label: 'Direct report',
        },
        {
          value: 'other',
          label: 'Other',
        },
      ],
      surveyLanguageOptions: [
        {
          value: 'english',
          label: 'English (United States)',
        },
        {
          value: 'fr',
          label: 'French (France)',
        },
        {
          value: 'du',
          label: 'Dutch (Netherlands)',
        },
        {
          value: 'po',
          label: 'Portuguese (Brazil)',
        },
      ],
    };
  },

  methods: {
    resetForm() {
      this.$refs.stakeholderForm.resetFields();
    },

    submit() {
      this.$refs.stakeholderForm.validate(async (valid) => {
        if (valid) {
          try {
            const response = await api.addSupporter(this.stakeholderForm);
            this.$emit('update:stakeholders', this.stakeholders.concat([response.data]));
            this.resetForm();
          } catch (err) {
            if (err.msg) {
              this.$message.error(err.msg);
            }
          }
        }
      });
    },

    async handleDelete(index) {
      try {
        await api.deleteSupporter(this.stakeholders[index].id);
        const data = this.stakeholders.filter((_, i) => i !== index);
        this.$emit('update:stakeholders', data);
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lgprStakeholders {
  .stakeholderTable {
    color: #606266;
  }

  .stakeholderTable,
  .stakeholderForm {
    margin: 20px 0;
  }

  .stakeholderForm {
    border-style: solid;
    border-width: 1px;
    border-radius: 4px;
    border-color: #eee;
    padding-top: 15px;
  }
}
</style>
